/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default {
    getCompanyID(state) {
      return state.companyID
    },
    getCompanyName(state) {
      return state.companyName
    },
    getCompanyWallet(state) {
      return state.wallet_amount
    },
    getAPIID(state) {
      return state.apiID
    },
    getLatitude(state) {
      return state.latitude
    },
    getLongitude(state) {
      return state.longitude
    },
    getCompany(state) {
      return state
    },
    getTotalUsers(state) {
      return state.total_users
    }
}
